import { post, get } from './restClient';
import { SESSION_END_POINTS, DATA_ADAPTER_END_POINTS } from './endpoints';
import { DILList, UserDetails } from './types';
import singleton from './singleton';

export async function callIsAuthenticated() {
  let authenticated = false;
  try {
    const userName = await callGetUsername();
    if (userName) {
      authenticated = true;
    }
  } finally {
    return authenticated;
  }
}

export async function callGetUsername() {
  return await get<UserDetails>(SESSION_END_POINTS.Current);
}

export async function callAuthenticateEndpoint(user: string, password: string): Promise<UserDetails> {
  return await post<UserDetails>(SESSION_END_POINTS.Login, { user, password });
}

export async function callAllowsAnonymous(): Promise<{ allowsAnonymous: boolean }> {
  return await get(SESSION_END_POINTS.AllowsAnonymous);
}

export async function logout(): Promise<void> {
  await post(SESSION_END_POINTS.Logout);
  singleton.unauthenticatedCallback?.();
}

export async function callGetDil(): Promise<DILList> {
  return await get(DATA_ADAPTER_END_POINTS.GetDefinitions);
}

// secondary login call for multifactor login
export const callMultiFactorAuthenticateEndpoint = async (pin: string): Promise<UserDetails> => {
  return await post<UserDetails>(SESSION_END_POINTS.MultiFactorAuthenticate, { pin });
};

// login using a json web token
export const callAuthenticateTokenEndpoint = async (token: string): Promise<UserDetails> => {
  return await post<UserDetails>(SESSION_END_POINTS.AuthenticateToken, { token });
};
